// src/pages/About/index.jsx
import React, { useState } from 'react';
import { Card, Avatar, Button, Form, Input, message } from 'antd';
import { EditOutlined, SaveOutlined, MailOutlined, LinkOutlined } from '@ant-design/icons';
import { defaultAboutInfoTemplate } from '../../api/mockData';
import './index.css';

const { TextArea } = Input;

const About = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();
  const [userInfo, setUserInfo] = useState(() => {
    const saved = localStorage.getItem('aboutInfo');
    return saved ? JSON.parse(saved) : defaultAboutInfoTemplate;
  });

  const handleSave = (values) => {
    setUserInfo(values);
    localStorage.setItem('aboutInfo', JSON.stringify(values));
    message.success('个人信息已保存');
    setIsEditing(false);
  };

  const handleCancel = () => {
    form.setFieldsValue(userInfo);
    setIsEditing(false);
  };

  return (
    <div className="about-page">
      <div className="page-header">
        <h2 className="page-title">
          <span className="chinese-seal-small">我</span>
          文物守护者
        </h2>
      </div>

      <div className="about-content">
        <Card className="profile-card">
          <div className="profile-header">
            <div className="avatar-section">
              <Avatar 
                size={120} 
                src={userInfo.avatar}
                className="antique-avatar"
              />
              {!isEditing && (
                <Button 
                  type="primary" 
                  icon={<EditOutlined />}
                  onClick={() => {
                    setIsEditing(true);
                    form.setFieldsValue(userInfo);
                  }}
                  className="edit-btn"
                >
                  编辑信息
                </Button>
              )}
            </div>
            
            {!isEditing ? (
              <div className="profile-info">
                <h3 className="profile-name">{userInfo.name}</h3>
                <p className="profile-intro">{userInfo.intro}</p>
                <div className="profile-details">
                  <p><MailOutlined /> {userInfo.email}</p>
                  <p>技术栈: {userInfo.techStack}</p>
                  <p>兴趣领域: {userInfo.interests}</p>
                </div>
              </div>
            ) : (
              <Form
                form={form}
                layout="vertical"
                onFinish={handleSave}
                className="edit-form"
              >
                <Form.Item name="name" label="姓名" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="intro" label="简介" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>
                <Form.Item name="email" label="邮箱">
                  <Input />
                </Form.Item>
                <Form.Item name="techStack" label="技术栈">
                  <Input />
                </Form.Item>
                <Form.Item name="interests" label="兴趣领域">
                  <Input />
                </Form.Item>
                <Form.Item name="details" label="详细描述">
                  <TextArea rows={4} />
                </Form.Item>
                <div className="form-actions">
                  <Button onClick={handleCancel}>取消</Button>
                  <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                    保存
                  </Button>
                </div>
              </Form>
            )}
          </div>

          {!isEditing && (
            <>
              <div className="profile-details-card">
                <h4>详细描述</h4>
                <p className="profile-details-text">{userInfo.details}</p>
              </div>
              
              <div className="social-links">
                <h4>联系方式</h4>
                <div className="links">
                  <Button type="link" icon={<LinkOutlined />} href={userInfo.github}>
                    GitHub
                  </Button>
                  <Button type="link" icon={<LinkOutlined />} href={userInfo.linkedin}>
                    LinkedIn
                  </Button>
                  <Button type="link" icon={<LinkOutlined />} href={userInfo.personalHomepage}>
                    个人主页
                  </Button>
                </div>
              </div>
            </>
          )}
        </Card>
      </div>
    </div>
  );
};

export default About;